export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-30-C-front-WEB-3bb4f325bf04dc11117c21bcc56b4af1.png";